import { render } from "./MdStepHeader.vue?vue&type=template&id=799fa79c"
import script from "./MdStepHeader.vue?vue&type=script&lang=js"
export * from "./MdStepHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__